import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import * as cx from 'classnames';
import { Navbar } from './model';
import { noDefault } from 'lib/eventWrappers';

import { ActionsMenuButton } from 'portcall/actionsmenubutton/view';
import { PCDismissible } from 'portcall/pcdismissible/view';

export const enum NavbarTab {
    Berths,
    Traffic,
    Pilots,
    More,
    Everyone,
    Me
};

{/* DC 3/10/17
    Removing Traffic link
    TODO: Add a link to go to (their) Berth Manager's Dashboard if user is a BM
          Looks like we'll want server validation to check permissions and then show?
          Yes but will hold off on this. Added to Berths Action menu as the *solution*
  */}

export let NavbarView = SuperCritical(({ model: m, tab } : { model : Navbar, tab? : NavbarTab }) => {
    return (
        <div className="navbar-component" role="navigation">
            <div className="top-bar">
                <div className="navbar-content clearfix">
                    <PortCallLinks model={m} />
                    {m.User() &&
                        <div className="user-info pc-text-background-color">
                            <span>{m.UserAbbreviation()}</span>
                            <a className="logout-link" href="" onClick={noDefault(m.Logout)}>Logout</a>
                        </div>
                    }
                </div>
            </div>
            <div className="bottom-bar">
                <div className="navbar-content clearfix">
                    <div className="homepage-link link-cell">
                        <a href="#">
                            {/* dynamically generate alternating colors of Domain Url */}
                            {m.Domain.DisplayableUrl().split('.').map((segment, i) =>
                                <span key={i} className={cx({
                                        'pc-text-accent': i % 2 === 0,
                                        'pc-text-default-color': i % 2 === 1
                                    })}>
                                    {(i > 0 ? '.' : '') + segment}
                                </span>
                            )}
                        </a>
                    </div>
                    <div>
                        <SiteLinks model={m} tab={tab} />
                    </div>
                    <div className="navbar-mobile-shell">
                        <ActionsMenuButton onClick={m.ToggleActionsMenu} />
                        <ActionsMenu model={m} />
                    </div>
                </div>
            </div>
        </div>
    );
});

let ActionsMenu = SuperCritical(({ model : m } : { model : Navbar }) => m.ShowActionsMenu() ?
    <div className="pc-actions">
        <PCDismissible className="pc-actions-menu pc-card" onDismiss={() =>m.ShowActionsMenu(false)}>
            <SiteLinks model={m} /* TODO: tab?? */ />
            <div>
                <PortCallLinks model={m} />
                {m.User() &&
                    <div className="action-item">
                        <div className="user-info pc-text-background-color">
                            <span>{m.UserAbbreviation()}</span>
                        </div>
                    </div>
                }
                {m.User() &&
                    <div className="action-item">
                        <div className="user-info pc-text-background-color">
                            <a className="logout-link" href="" onClick={noDefault(m.Logout)}>Logout</a>
                        </div>
                    </div>
                }
            </div>
        </PCDismissible>
    </div> : null
);

let SiteLinks = SuperCritical(({ model: m, tab } : { model : Navbar, tab? : NavbarTab }) => {
    const user = m.User();

    if (!user) return null;

    const settings = m.Domain.Settings();

    return (
        <ul className="site-links nav-links">
            <li className={cx('link-cell', { active: tab === NavbarTab.Berths })}>
                <a className="" href="#!schedulegrid">Berths</a>
            </li>
            {m.Domain.HasActivePilots() && user.CanViewPilotPages() && 
                // Only show Pilots link for the 1st Pilot Agency in the Domain
                // Will need to revise if ever have installation w/ multiple Pilot Agencies
                <li className={cx('link-cell', { active: tab === NavbarTab.Pilots })}>
                    <a className="" href={'#!dispatchdashboard?id=' + m.Domain.PilotAgencyIds()[0]}>Pilots</a>
                </li>
            }
            <li className={cx('link-cell', { active: tab === NavbarTab.More})}>
                <a className="" href="#!morepage">More</a>
            </li>
            <li className="pipe-character ">
                |
            </li>
            <li className={cx('link-cell', { active: tab === NavbarTab.Everyone })}>
                <a className="" href="#!organizations">Everyone</a>
            </li>
            <li className={cx('link-cell', { active: tab === NavbarTab.Me })}>
                <a className="" href="#!mepage">Me</a>
            </li>
        </ul>
    );
});

let PortCallLinks = SuperCritical(( { model : m } : { model : Navbar }) => {
    const user = m.User(),
        settings = m.Domain.Settings();

    return (
        <ul className="portcall-links nav-links">
            <li>
                <a href="http://portcall.com/">
                    <span className="pc-text-background-color">Portcall</span>
                    <span className="pc-text-accent">.com</span>
                </a>
            </li>
            <li>
                <a href='http://support.portcall.com/' target="_blank">Help</a>
            </li>
        </ul>
    );
});


// WEBPACK FOOTER //
// ./apps/portcall/navbar/view.tsx